<script>

	import Layout from '@layouts/main'
	import appConfig from '@src/app.config'
	import api from '@/odooapi'
	import rpc from '@/odoorpc'
	import or from 'vuelidate/lib/validators/or'



	/**
	 * Dashboard-1 Component
	 */
	export default {
		page: {
			title: '钢网管理',
			meta: [{
				name: 'description',
				content: appConfig.description
			}],
		},
		components: {
			Layout,
		},
		data() {
			return {
				showSearch:true,
				queryParams:{
					name:undefined,
					product_tmpl_name:undefined
				},
				stList:[],
				paginationData:{
					// 总数据条数
					total:0,
					// 当前页
					currentPage:1,
					// 每页展示几条数据
					page_Size:10,
				}
			}
		},
		created(){
			this.getData()
		},
		methods:{
			getData(){
				rpc.web.dataset.call_kw({
					model:'product.template',
					method:'search_product_template_st',
					args:[],
					kwargs:{
						"currentPage":this.paginationData.currentPage,
						"pageSize":this.paginationData.page_Size,
						"name":this.queryParams.name,
						"product_tmpl_name":this.queryParams.product_tmpl_name
					}
				})
				.then(res=>{
					this.stList = res.data
					this.paginationData.total = res.total
				})
			},
			// 搜索按钮
			handleQuery(){
				if(!this.queryParams.name || !this.queryParams.product_tmpl_name){
					this.paginationData.currentPage = 1
					
				}
				this.getData()
			},
			// 重置按钮
			resetQuery(){
				this.queryParams.name = ""
				this.queryParams.product_tmpl_name = ""
				this.paginationData.currentPage = 1
				this.getData()
			},

			 // 分页
			handlePageSize(page_size){
				this.paginationData.page_Size=page_size
				// 这里写获取的的方法
				this.getData()

			},
			handlePageChange(pageNum){
				this.paginationData.currentPage=pageNum
				// 这里写获取的的方法
				this.getData()
			},
		}
		
	}
</script>

<template>
	<Layout>
		<div class="row page-title align-items-center">
			<div class="col-sm-4 col-xl-6">
				<h4 class="mb-1 mt-0">钢网管理</h4>
			</div>
			<div class="col-sm-8 col-xl-6">
				<form class="form-inline float-sm-right mt-3 mt-sm-0">
					<!-- <div class="form-group mb-sm-0 mr-2">
						<flat-pickr v-model="selectedDate" class="form-control" :config="dateConfig" name="date">
						</flat-pickr>
					</div> -->
					<div class="btn-group">
						<!-- <b-dropdown variant="primary" right>
							<template v-slot:button-content>
								<i class="uil uil-file-alt mr-1"></i>Download
								<i class="icon">
									<feather type="chevron-down" class="align-middle"></feather>
								</i>
							</template>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="mail" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Email</span>
							</b-dropdown-item>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="printer" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Print</span>
							</b-dropdown-item>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="file" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Re-Generate</span>
							</b-dropdown-item>
						</b-dropdown> -->
					</div>
				</form>
			</div>
		</div>

    <div class="row">
      <div class="col">
		<div class="card">
			<div class="card-body p-0">
				<el-form :model="queryParams" ref="queryForm" v-show="showSearch" :inline="true" class="p-3">
					<el-form-item label="钢网编号" prop="name">
						<el-input v-model="queryParams.name" placeholder="请输入钢网编号" clearable size="small"
								style="width: 240px" @keyup.enter.native="handleQuery"/>
					</el-form-item>
					<el-form-item label="规格型号" prop="product_tmpl_name">
						<el-input v-model="queryParams.product_tmpl_name" placeholder="请输入规格型号" clearable size="small"
								style="width: 240px" @keyup.enter.native="handleQuery"/>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
						</el-button>
						<el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>

				<div style="margin-top: -0.6rem;">
					<el-table :data="stList" style="width: 100%" class="p-3">
						<el-table-column type="selection" width="55" align="center"/>
						<!-- <el-table-column prop="partner_name" label="客户"/> -->
						<el-table-column prop="name" label="钢网编号"/>
						<el-table-column prop="st_thickness" label="厚度"/>

						<el-table-column  label="规格型号">
							<template slot-scope="scope">
								<div v-for="(st, idx) in scope.row.parent_pt_nams" :key="idx">
									<el-tag type="info" style="margin-bottom: 5px;">{{st}}</el-tag>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="st_state" label="钢网状态"/>
					</el-table>
				</div>

				<el-pagination
					background
					style="margin-top: 20px; text-align: right;"
					layout="total, sizes, prev, pager, next, jumper"
					:total="paginationData.total"
					:current-page="paginationData.currentPage"
					:page-size="paginationData.page_Size"
					:page-sizes="[10, 30, 50]"
					@size-change="handlePageSize"
					@current-change="handlePageChange"
					>
				</el-pagination>

			</div>
		</div>
	  </div>
    </div>
	</Layout>
</template>
